export default "__VITE_ASSET__fcac514d__"